import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "../";
import localData from "../../localData";
import { useGlobalContext } from "../../context";
import Validation from "../../utils/validation";

export default function Footer() {
    const { facebook, instagram, twitter } = localData.images;

    const {isModalShown,setIsModalShown} = useGlobalContext()

    useEffect(()=>{
        Validation.init();
    },[])

    return (
        <footer className="footer bg-dark">
            <div className="container">
                <div className="footer-center">
                    <div className="info">
                        <h3 className="info-title">Who we are</h3>
                        <p className="info-description">
                            At Mowida, we listen, learn and understand before we build. We are a proven full-service
                            marketing and branding agency with a strong focus on emerging brands, start-ups and MSMES.
                        </p>
                        <Button className="btn btn-xl btn-outline-light subscribe-btn"  onClick={() => setIsModalShown(true)}>
                            <span>SUBSCBRIBE TO OUR NEWSLETTER</span>
                        </Button>
                    </div>
                    <div className="quick-links">
                        <h4 className="quick-links-title">quick links</h4>
                        <Link to="/">
                            <Button className="btn btn-text-light">Home</Button>
                        </Link>
                        <Link to="/what-we-do">
                            <Button className="btn btn-text-light">what we do</Button>
                        </Link>
                        <Link to="/about">
                            <Button className="btn btn-text-light">who we are</Button>
                        </Link>
                        <Link to="/works">
                            <Button className="btn btn-text-light">works</Button>
                        </Link>
                        <Link to="/contact">
                            <Button className="btn btn-text-light">speak to an expert</Button>
                        </Link>
                        <Link to="/blog">
                            <Button className="btn btn-text-light">blog</Button>
                        </Link>
                    </div>

                    <div className="contact-links">
                        <h4 className="contact-links-title">contact us</h4>
                        <a
                            target="_blank"
                            href="https://www.google.com/maps/place/36+Agboyi+Road,+Ketu+105102,+Lagos,+Nigeria/@6.5862893,3.4023731,20.25z/data=!4m5!3m4!1s0x103b92bf0fb200cf:0x672e7d5442e1837a!8m2!3d6.5863537!4d3.4024288"
                        >
                            <Button className="btn btn-text-light map-btn">No 36 Agboyi road, Ogudu, Lagos</Button>
                        </a>
                        <a href="tel:08085370831">
                            <Button className="btn btn-text-light">08085370831</Button>
                        </a>
                        <a href="mailto:mowidadigital@gmail.com" target="_blank">
                            <Button className="btn btn-text-light">mowidadigital@gmail.com</Button>
                        </a>
                    </div>

                    <div className="social-links">
                        <h4 className="social-links-title">follow us</h4>
                     <div className="social-links-center">
                           <Button className="btn btn-text-light rounded-circle">
                               <a target="_blank" href="https://www.facebook.com/gift.mowida">
                                   <img src={facebook} alt="" />
                               </a>
                           </Button>
                           <Button className="btn btn-text-light rounded-circle">
                               <a target="_blank" href="https://www.instagram.com/mowidamedia/">
                                   <img src={instagram} alt="" />
                               </a>
                           </Button>
                           <Button className="btn btn-text-light rounded-circle">
                               <a href="#/">
                                   <img src={twitter} alt="" />
                               </a>
                           </Button>
                     </div >
                    </div>
                </div>
            </div>
        </footer>
    );
}
